<template>
    <font-awesome-icon icon="info-circle" @click="toDetalhar()" size="lg" class="icon-button p-text-primary" title="Detalhar" />
</template>

<script>
export default {
    props: {
        evento: {
            type: Object,
        },
    },

    methods: {
        toDetalhar() {
            this.$router.push({
                name: 'Checkins_Eventos_Detalhar',
                params: {
                    id: this.evento.eventoId,
                },
            });
        },
    },
};
</script>
